import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { FormInput } from "../FormComponents";
import { requiredValidator } from "../Validators";
import { useEffect } from "react";

const EditSiteForm = (props: any) => {
  const handleSubmit = (dataItem: any) => {
    // alert(JSON.stringify(dataItem, null, 2));
    props.onSiteSubmit(dataItem);
  };

  return (
    <Form
      onSubmit={handleSubmit}
      render={(formRenderProps) => (
        <FormElement style={{ padding: "1rem", marginBottom: "5rem" }}>
          <fieldset className={"k-form-fieldset"}>
            <div className="form__subtitle">
              Add site details:
              <button
                className="form__reset__button"
                onClick={formRenderProps.onFormReset}
              >
                Clear fields
              </button>
            </div>

            <Field
              name={"siteAddr"}
              component={FormInput}
              label={"Site address:"}
              placeholder={"Enter an address:"}
              validator={requiredValidator}
            />

            <Field
              name={"postcode"}
              component={FormInput}
              label={"Postcode: "}
              placeholder={"Enter a postcode:"}
            />
          </fieldset>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              bottom: 0,
              left: 0,
              width: "100%",
              padding: "1rem 2rem 1rem 2rem",
              position: "absolute",
              zIndex: "10000",
            }}
          >
            <button
              type={"submit"}
              disabled={!formRenderProps.allowSubmit}
              style={{
                width: "100%",
                marginTop: "0.5rem",
                height: "3rem",
                backgroundColor: "rgb(174 199 65)",
                color: "rgb(71 83 21)",
                border: 0,
                borderRadius: "0.3rem",
              }}
            >
              Add site
            </button>
          </div>
        </FormElement>
      )}
    />
  );
};

export default EditSiteForm;
